angular.module('userSettingsMod')

.controller('repositoriesCtrl', ['$scope', 'GhDialog', 'RepositoriesService', 'SshKeysService', 'localizationService', async function($scope, GhDialog, RepositoriesService, SshKeysService, localizationService) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.tabs = [
    { name: $scope.translate('Repositories') },
    { name: $scope.translate('SSH Keys') }
  ];
  $scope.currentTab = 0;
  $scope.mobileTabDetailOpen = false;
  $scope.switchTab = function (index) {
    $scope.currentTab = index;
    $scope.mobileTabDetailOpen = true;
    $scope.nav.title = $scope.tabs[index].name;
    $scope.nav.onBack = function(){
      $scope.mobileTabDetailOpen = false;
      $scope.nav.onBack = null;
      $scope.nav.title = null;
    };
  };

  $scope.repositories = [];
  $scope.sshKeys = [];

  $scope.getRepositories = async function() {
    try {
      $scope.repositories = await RepositoriesService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  $scope.getSshKeys = async function() {
    try {
      $scope.sshKeys = await SshKeysService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  $scope.showDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        repositories: $scope.repositories,
        sshKeyOptions: $scope.sshKeys.map(k => ({ name: k.name, value: k._id })),
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: `
          <div class="edit_repo-popup">
            <div class="dialog-share-group">
              <span gh-icon="code 0D99FF 65px"></span>
              <p class="dialog-share-group__title">{{translate('Add Repository')}}</p>
            </div>

            <div class="dialog-share-group__content">
              <div class="dialog-share-group__content__input">
                <label>{{translate('Repository name')}}</label>
                <gh-input ng-model="repo.repo_name" placeholder="{{translate('Repository name')}}"></gh-input>
              </div>

              <div class="dialog-share-group__content__input">
                <label for="repo_type">{{translate('Type')}}</label>
                <select id="repo_type" ng-model="repo.repo_type">
                  <option value="">Select type...</option>
                  <option value="skills">Skills</option>
                  <option value="apps">Apps</option>
                </select>
              </div>

              <div class="dialog-share-group__content__input">
                <label>{{translate('Description')}}</label>
                <textarea
                  class="edit-repo-textarea disable-gudhub-styles"
                  ng-model="repo.description"
                  placeholder="{{translate('Description')}}"
                ></textarea>
              </div>

              <div class="dialog-share-group__content__input">
                <label>{{translate('SSH Keys')}}</label>
                <gh-input-list
                  gh-editable="true"
                  add-button-name="{{translate('Add Key')}}"
                  gh-dropdown="sshKeyOptions"
                  gh-model="selectedSshKeys"
                  gh-data-type="text_opt"
                  size="large"
                  gh-multiple-selection="false">
                </gh-input-list>
              </div>

              <p class="error_message" ng-if="errMessage">{{errMessage}}</p>

              <div class="dialog-share-group__content__buttons">
                <button
                  class="dialog-share-group__content__buttons__add btn btn-blue"
                  ng-click="addRepo()"
                >
                  {{translate('Add')}}
                </button>

                <button
                  class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse"
                  ng-click="cancel()"
                >
                  {{translate('Cancel')}}
                </button>
              </div>
            </div>
          </div>
        `
      },
      controller: ['$scope', 'repositories', 'sshKeyOptions', 'safeApply', 'localizationService', function($scope, repositories, sshKeyOptions, safeApply, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';
        $scope.sshKeyOptions = sshKeyOptions;
        $scope.selectedSshKeys = [];

        $scope.repo = {
          repo_name: '',
          repo_type: '',
          description: ''
        };

        $scope.addRepo = async function() {
          if (!$scope.repo.repo_name || !$scope.repo.repo_name.trim()) {
            $scope.errMessage = 'Please, type repository name';
            return;
          }

          if (!$scope.repo.repo_type) {
            $scope.errMessage = 'Please, select repository type';
            return;
          }

          try {
            const createdRepo = await RepositoriesService.create(
              $scope.repo.repo_name.trim(),
              $scope.repo.repo_type,
              $scope.repo.description.trim()
            );

            if ($scope.selectedSshKeys.length) {
              await RepositoriesService.update(createdRepo._id, { ssh_keys: $scope.selectedSshKeys });
              createdRepo.ssh_keys = $scope.selectedSshKeys.slice();
            }

            repositories.push(createdRepo);
            safeApply();
            $scope.cancel();
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.$evalAsync();
          }
        };
      }]
    });
  };

  $scope.showAddSSHKeyDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        sshKeys: $scope.sshKeys,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: `
          <div class="edit_repo-popup">
            <div class="dialog-share-group">
              <span gh-icon="lock 0D99FF 65px"></span>
              <p class="dialog-share-group__title">{{translate('Add SSH Key')}}</p>
            </div>

            <div class="dialog-share-group__content">
              <div class="dialog-share-group__content__input">
                <label>{{translate('Key name')}}</label>
                <gh-input ng-model="sshKey.name" placeholder="e.g. my-laptop"></gh-input>
              </div>

              <div class="dialog-share-group__content__input">
                <label>{{translate('Public SSH Key')}}</label>
                <textarea
                  class="edit-repo-textarea ssh-key-textarea disable-gudhub-styles"
                  ng-model="sshKey.public_ssh_key"
                  placeholder="Paste your public SSH key here (ssh-rsa AAAA...)"
                ></textarea>
              </div>

              <p class="error_message" ng-if="errMessage">{{errMessage}}</p>

              <div class="dialog-share-group__content__buttons">
                <button
                  class="dialog-share-group__content__buttons__add btn btn-blue"
                  ng-click="addKey()"
                >
                  {{translate('Add')}}
                </button>

                <button
                  class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse"
                  ng-click="cancel()"
                >
                  {{translate('Cancel')}}
                </button>
              </div>
            </div>
          </div>
        `
      },
      controller: ['$scope', 'sshKeys', 'safeApply', 'SshKeysService', 'localizationService', function($scope, sshKeys, safeApply, SshKeysService, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';

        $scope.sshKey = {
          name: '',
          public_ssh_key: ''
        };

        $scope.addKey = async function() {
          if (!$scope.sshKey.name || !$scope.sshKey.name.trim()) {
            $scope.errMessage = 'Please, enter a key name';
            return;
          }

          if (!$scope.sshKey.public_ssh_key || !$scope.sshKey.public_ssh_key.trim()) {
            $scope.errMessage = 'Please, paste your public SSH key';
            return;
          }

          try {
            const createdKey = await SshKeysService.create(
              $scope.sshKey.name.trim(),
              $scope.sshKey.public_ssh_key.trim()
            );

            sshKeys.push(createdKey);
            safeApply();
            $scope.cancel();
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.$evalAsync();
          }
        };
      }]
    });
  };

  await Promise.all([$scope.getRepositories(), $scope.getSshKeys()]);

}]);
